import { Flex, Box, Heading } from '@chakra-ui/react';

type Props = {
  obtDisabledMessage?: string;
};

export const DisableObt = (props: Props) => {
  return (
    <Flex flex='1' overflowY='auto' marginTop={{ base: '55px', sm: '55px', md: '80px' }} id='mainLayoutContainer'>
      <Box width='100%'>
        <Box width='100%' textAlign={'center'}>
          <Heading size={'lg'} paddingTop={'20px'}>
            Services Unavailable
          </Heading>
          <Heading size={'md'} paddingTop={'20px'}>
            Sorry, Frontier Online is currently unavailable. Please check back later.
            <br />
            <br />
            {props.obtDisabledMessage ? (
              <>
                {props.obtDisabledMessage}
                <br />
                <br />
              </>
            ) : (
              ' '
            )}
            If your request is urgent, contact our reservations team directly at{' '}
            <a href={'mailto:reservations@frontierlodging.com'}>reservations@frontierlodging.com</a> or call{' '}
            <a href={'tel:1-866-468-2488'}>1-866-468-2488</a>.
          </Heading>
        </Box>
      </Box>
    </Flex>
  );
};
